module.exports = __webpack_public_path__ + "img/banner-hen.3aab008c.png";